import styled from "styled-components";

export const FixedDescription = styled.div`
  .ant-descriptions .ant-descriptions-view > table {
    table-layout: fixed !important;
  }
  .ant-table-wrapper tr.ant-table-expanded-row .ant-descriptions-view table {
    width: 100% !important;
    flex: unset !important;
  }
  .ant-descriptions-view table {
    width: 100% !important;
    flex: unset !important;
  }

  .ant-timeline-item-last {
    .ant-timeline-item-content {
      min-height: unset !important;
    }
    padding-bottom: 0 !important;
  }
`;
